// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3CdNw","validationTips":"StatementDescriptor_validationTips__211Mt"};